import type { PM } from '@kulee/helper'
import type { Context, SDKI } from './types'

class BaseModule {
  protected context: Context
  protected pm: PM
  protected sdk: SDKI

  constructor(context: Context) {
    this.context = context

    this.pm = this.context.pm
    this.sdk = this.context.sdk
  }
}

export default BaseModule
